import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import * as Vars from '../../../../data/vars.js';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "manage-prices-for-multiple-products"
    }}>{`Manage prices for multiple products`}</h1>
    <p>{`Adobe Commerce provides REST endpoints that allow you to update multiple special prices, tier prices, base prices, or cost values with a single call.`}</p>
    <p>{`The calls that update special and tier prices mimic the options available on a product's `}<strong parentName="p">{`Advanced Pricing`}</strong>{` screen in Admin.`}</p>
    <h2 {...{
      "id": "manage-special-prices"
    }}>{`Manage special prices`}</h2>
    <p>{`The  `}<inlineCode parentName="p">{`SpecialPriceStorageInterface`}</inlineCode>{` service provides the means to efficiently schedule special prices for one or more products in a store's catalog. When you use these calls, you do not provide detailed information about the product.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`POST /V1/products/special-price`}</inlineCode>{` call sets special prices for the following product types:`}</p>
    <ul>
      <li parentName="ul">{`Simple`}</li>
      <li parentName="ul">{`Bundle`}</li>
      <li parentName="ul">{`Virtual`}</li>
      <li parentName="ul">{`Downloadable`}</li>
    </ul>
    <p><strong parentName="p">{`Service Name:`}</strong></p>
    <p><inlineCode parentName="p">{`SpecialPriceStorageInterface`}</inlineCode></p>
    <p><strong parentName="p">{`REST Endpoints:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-http"
      }}>{`POST /V1/products/special-price
POST /V1/products/special-price-information
POST /V1/products/special-price-delete
`}</code></pre>
    <p><strong parentName="p">{`SpecialPriceStorageInterface Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Format`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Requirements`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`price`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The special price of the product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`float`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for setting or deleting a special price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`store_id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The store ID  to apply the special price`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for setting or deleting a special price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`sku`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The SKU of the product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for setting or deleting a special price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`skus`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of SKU values that is specified when retrieving a list of special prices`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for retrievals`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`price_from`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The date and time the special price goes into effect. The date/time format is `}<inlineCode parentName="td">{`YYYY-MM-DD hh:mm:ss`}</inlineCode>{`. The specified time must be later than the current time.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required in `}<Vars.sitedatavaree />{`. Optional in `}<Vars.sitedatavarce />{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`price_to`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The date and time the special price ends. The date/time format is `}<inlineCode parentName="td">{`YYYY-MM-DD hh:mm:ss`}</inlineCode>{` If no value is specified, the special price does not expire.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required in `}<Vars.sitedatavaree />{`. Optional in `}<Vars.sitedatavarce />{`.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "set-special-prices"
    }}>{`Set special prices`}</h3>
    <p>{`All calls to set special prices must include the `}<inlineCode parentName="p">{`store_id`}</inlineCode>{`, `}<inlineCode parentName="p">{`sku`}</inlineCode>{`, and `}<inlineCode parentName="p">{`price`}</inlineCode>{` parameters. If the call is sent to an `}<Vars.sitedatavaree />{` installation, the call must also include the `}<inlineCode parentName="p">{`price_from`}</inlineCode>{` parameter. If the call is sent to a `}<Vars.sitedatavarce />{` installation, then the `}<inlineCode parentName="p">{`price_from`}</inlineCode>{` parameter is optional.`}</p>
    <p>{`For bundled products, the value of the `}<inlineCode parentName="p">{`price`}</inlineCode>{` parameter must be expressed as a discount percentage.`}</p>
    <p>{`You can set multiple special prices in a single call, as shown in the example below. The call sets special prices for a simple product, downloadable product, and bundle product for two days.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`The special price endpoint can only use a global price scope (`}<strong parentName="p">{`Stores > Settings > Configuration > Catalog > Catalog > Price > Catalog Price Scope`}</strong>{`). The mandatory parameters `}<inlineCode parentName="p">{`price_from`}</inlineCode>{` and `}<inlineCode parentName="p">{`price_to`}</inlineCode>{` trigger a catalog schedule, which is currently only supported on a global price scope. Overlapping date ranges on multiple stores will trigger an error that states: "Future Update already exists in this time range. Set a different range and try again."`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/special-price`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "prices": [
    {
      "price": 29.95,
      "store_id": 0,
      "price_from": "2017-07-15 00:00:00",
      "price_to": "2017-07-16 23:59:59",
      "sku": "24-WB06"
    },
    {
      "price": 19.95,
      "store_id": 0,
      "price_from": "2017-07-15 00:00:00",
      "price_to": "2017-07-16 23:59:59",
      "sku": "240-LV06"
    },
    {
      "price": 5,
      "store_id": 0,
      "price_from": "2017-07-15 00:00:00",
      "price_to": "2017-07-16 23:59:59",
      "sku": "24-WG080"
    }
  ]
}

`}</code></pre>
    <h4 {...{
      "id": "response"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// Returns an empty array
[] 
`}</code></pre>
    <h3 {...{
      "id": "get-special-prices"
    }}>{`Get special prices`}</h3>
    <p>{`The following call returns the special price information for three SKU values.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/special-price-information`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-1"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "skus": [
    "24-WB06",
    "240-LV06",
    "24-WG080"
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-1"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
    {
        "price": 29.949999999999999,
        "store_id": 0,
        "sku": "24-WB06",
        "price_from": "2017-07-15 00:00:00",
        "price_to": "2017-07-16 23:59:59"
    },
    {
        "price": 19.949999999999999,
        "store_id": 0,
        "sku": "240-LV06",
        "price_from": "2017-07-15 00:00:00",
        "price_to": "2017-07-16 23:59:59"
    },
    {
        "price": 5,
        "store_id": 0,
        "sku": "24-WG080",
        "price_from": "2017-07-15 00:00:00",
        "price_to": "2017-07-16 23:59:59"
    }
]
`}</code></pre>
    <h3 {...{
      "id": "delete-a-special-price"
    }}>{`Delete a special price`}</h3>
    <p>{`If any item to be deleted has an invalid `}<inlineCode parentName="p">{`price`}</inlineCode>{`, `}<inlineCode parentName="p">{`store_id`}</inlineCode>{`, `}<inlineCode parentName="p">{`sku`}</inlineCode>{` or `}<inlineCode parentName="p">{`date`}</inlineCode>{`, Commerce marks the item as failed and excludes it from the delete list. Valid items are deleted as requested.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/special-price-delete`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-2"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "prices": [
    {
      "price": 29.95,
      "store_id": 0,
      "price_from": "2017-07-15 00:00:00",
      "price_to": "2017-07-16 23:59:59",
      "sku": "24-WB06"
    },
    {
      "price": 19.95,
      "store_id": 0,
      "price_from": "2017-07-15 00:00:00",
      "price_to": "2017-07-16 23:59:59",
      "sku": "240-LV06"
    },
    {
      "price": 5,
      "store_id": 0,
      "price_from": "2017-07-15 00:00:00",
      "price_to": "2017-07-16 23:59:59",
      "sku": "24-WG080"
    }
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-2"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// Returns an empty array
[] 
`}</code></pre>
    <h2 {...{
      "id": "manage-tier-prices"
    }}>{`Manage tier prices`}</h2>
    <p>{`Tier pricing offers a quantity discount to members of a specific customer group and website.  The  `}<inlineCode parentName="p">{`TierPriceStorageInterface`}</inlineCode>{` service provides an efficient means to set tier prices for one or more products without requiring detailed information about each product.`}</p>
    <p>{`You can use REST endpoints to set tier prices for the following product types:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Product type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Tier price types`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Simple`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`fixed, discount`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bundle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`discount`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`fixed, discount`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Downloadable`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`fixed, discount`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Service Name:`}</strong></p>
    <p><inlineCode parentName="p">{`TierPriceStorageInterface`}</inlineCode></p>
    <p><strong parentName="p">{`REST Endpoints:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-http"
      }}>{`POST /V1/products/tier-prices
PUT /V1/products/tier-prices
POST /V1/products/tier-prices-information
POST /V1/products/tier-prices-delete
`}</code></pre>
    <p><strong parentName="p">{`TierPriceStorageInterface Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Format`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Requirements`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`price`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The discounted product price for the quantity purchased`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`float`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set, update, or delete a tier price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`price_type`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Must be `}<inlineCode parentName="td">{`fixed`}</inlineCode>{` (the set price) or `}<inlineCode parentName="td">{`discount`}</inlineCode>{` (percent discount)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set, update, or delete a tier price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`website_id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The website ID  to apply the tier price`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set, update, or delete a tier price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`sku`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The SKU of the product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set, update, or delete a tier price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`skus`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of SKU values that is specified when retrieving a list of tier prices`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for retrievals`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`customer_group`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A specific customer group that qualifies to receive the tier price discount`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set, update, or delete a tier price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`quantity`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The quantity that must be purchased to receive the tier price`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`float`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set, update, or delete a tier price`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "set-tier-prices"
    }}>{`Set tier prices`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`POST /V1/products/tier-prices`}</inlineCode>{` call adds new tier prices or updates existing prices. You can specify tier prices for multiple products in the same call.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/tier-prices`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-3"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`
{
  "prices": [
    {
      "price": 10,
      "price_type": "fixed",
      "website_id": 0,
      "sku": "24-UG04",
      "customer_group": "General",
      "quantity": 3
    },
    {
      "price": 8,
      "price_type": "fixed",
      "website_id": 0,
      "sku": "24-UG04",
      "customer_group": "General",
      "quantity": 5
    },
    {
      "price": 6,
      "price_type": "fixed",
      "website_id": 0,
      "sku": "24-UG04",
      "customer_group": "General",
      "quantity": 10
    }
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-3"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// Returns an empty array
[] 
`}</code></pre>
    <h3 {...{
      "id": "replace-existing-tier-prices"
    }}>{`Replace existing tier prices`}</h3>
    <p>{`The replace request removes all existing tier prices for a specified product and adds new rows for this same product instead.`}</p>
    <p>{`The following example removes the $10 tier price for `}<inlineCode parentName="p">{`sku`}</inlineCode>{` 24-UG04 and changes the customer group for the `}<inlineCode parentName="p">{`sku`}</inlineCode>{`'s other tier prices.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`PUT <host>/rest/<store_code>/V1/products/tier-prices`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-4"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "prices": [
    {
      "price": 8,
      "price_type": "fixed",
      "website_id": 0,
      "sku": "24-UG04",
      "customer_group": "NOT LOGGED IN",
      "quantity": 5
    },
    {
      "price": 5,
      "price_type": "fixed",
      "website_id": 0,
      "sku": "24-UG04",
      "customer_group": "NOT LOGGED IN",
      "quantity": 310
    }
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-4"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// Returns an empty array
[] 
`}</code></pre>
    <h3 {...{
      "id": "get-tier-prices"
    }}>{`Get tier prices`}</h3>
    <p>{`Commerce returns all active tier prices for the specified list of `}<inlineCode parentName="p">{`skus`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/tier-prices-information`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-5"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "skus": [
    "24-UG04",
    "24-UG01"
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-5"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
    {
        "price": 8,
        "price_type": "fixed",
        "website_id": 0,
        "sku": "24-UG04",
        "customer_group": "General",
        "quantity": 5
    },
    {
        "price": 6,
        "price_type": "fixed",
        "website_id": 0,
        "sku": "24-UG04",
        "customer_group": "General",
        "quantity": 10
    },
    {
        "price": 10,
        "price_type": "fixed",
        "website_id": 0,
        "sku": "24-UG04",
        "customer_group": "General",
        "quantity": 3
    },
    {
        "price": 5,
        "price_type": "discount",
        "website_id": 0,
        "sku": "24-UG01",
        "customer_group": "General",
        "quantity": 3
    }
]
`}</code></pre>
    <h3 {...{
      "id": "delete-tier-prices"
    }}>{`Delete tier prices`}</h3>
    <p>{`You must specify each tier price that is to be deleted. You can delete multiple tier prices in a single call.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/tier-prices-delete`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-6"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "prices": [
    {
      "price": 10,
      "price_type": "fixed",
      "website_id": 0,
      "sku": "24-UG04",
      "customer_group": "General",
      "quantity": 3
    }
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-6"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// Returns an empty array
[] 
`}</code></pre>
    <h2 {...{
      "id": "manage-base-prices"
    }}>{`Manage base prices`}</h2>
    <p>{`A base price is the price of a product, before any discounts or extra costs (such as shipping or taxes) are applied.  The  `}<inlineCode parentName="p">{`BasePriceStorageInterface`}</inlineCode>{` service provides an efficient means to set base prices for one or more products without requiring detailed information about each product.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`You cannot delete a base price. It can only be changed to another value (0 or greater).`}</p>
    <p><strong parentName="p">{`REST Endpoints:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-http"
      }}>{`POST /V1/products/base-prices
POST /V1/products/base-prices-information
`}</code></pre>
    <p><strong parentName="p">{`BasePriceStorageInterface Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Format`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Requirements`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`price`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The base price of the item`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`float`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set a base price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`store_id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The store ID  to apply the base price`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set a base price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`sku`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The SKU of the product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set a base price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`skus`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of SKU values that is specified when retrieving a list of base prices`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for retrievals`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "set-base-prices"
    }}>{`Set base prices`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`POST /V1/products/base-prices`}</inlineCode>{` call can set base prices for the following types of products:`}</p>
    <ul>
      <li parentName="ul">{`Simple`}</li>
      <li parentName="ul">{`Virtual`}</li>
      <li parentName="ul">{`Downloadable`}</li>
      <li parentName="ul">{`Bundle (fixed price type only)`}</li>
    </ul>
    <p>{`The following example sets the base price for a simple and a downloadable product.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/base-prices`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-7"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "prices": [
  {
    "price": 12,
    "store_id": 0,
    "sku": "24-UG04"
  },
  {
    "price": 22,
    "store_id": 0,
    "sku": "240-LV06"
  }
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-7"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// Returns an empty array
[] 
`}</code></pre>
    <h3 {...{
      "id": "get-base-prices"
    }}>{`Get base prices`}</h3>
    <p>{`The following example returns the base prices for a simple and a downloadable product.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/base-prices-information`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-8"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "skus": [
    "24-UG04",
    "240-LV06"
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-8"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "price": 12,
    "store_id": 0,
    "sku": "24-UG04"
  },
  {
    "price": 22,
    "store_id": 0,
    "sku": "240-LV06"
  }
]
`}</code></pre>
    <h2 {...{
      "id": "manage-cost-values"
    }}>{`Manage cost values`}</h2>
    <p>{`The cost is the actual cost of a product. Tracking costs is optional, but having this information available can be helpful when you are setting discounts.`}</p>
    <p><strong parentName="p">{`REST Endpoints:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-http"
      }}>{`POST /V1/products/cost
POST /V1/products/cost-information
POST /V1/products/cost-delete
`}</code></pre>
    <p><strong parentName="p">{`CostStorageInterface Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Format`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Requirements`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`cost`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The amount the item costs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`float`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set or delete a cost value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`store_id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The store ID  to apply the cost value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set or delete a cost value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`sku`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The SKU of the product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required to set or delete a cost value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`skus`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of SKU values that is specified when retrieving a list of cost values`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for retrievals`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "set-cost-values"
    }}>{`Set cost values`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`POST /V1/products/cost`}</inlineCode>{` call can set the cost values for the following types of products:`}</p>
    <ul>
      <li parentName="ul">{`Simple`}</li>
      <li parentName="ul">{`Virtual`}</li>
      <li parentName="ul">{`Downloadable`}</li>
    </ul>
    <p>{`The following example sets the cost value for a simple and a downloadable product.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/cost`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-9"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "prices": [
    {
      "cost": 18,
      "store_id": 0,
      "sku": "24-WB03"
    },
    {
      "cost": 2,
      "store_id": 0,
      "sku": "240-LV09"
    }
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-9"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// Returns an empty array
[] 
`}</code></pre>
    <h3 {...{
      "id": "get-cost-values"
    }}>{`Get cost values`}</h3>
    <p>{`The following example returns the cost values for a simple and a downloadable product.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/cost-information`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-10"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "skus": [
    "24-WB03",
    "240-LV09"
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-10"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "cost": 18,
    "store_id": 0,
    "sku": "24-WB03"
  },
  {
    "cost": 2,
    "store_id": 0,
    "sku": "240-LV09"
  }
]
`}</code></pre>
    <h3 {...{
      "id": "delete-cost-values"
    }}>{`Delete cost values`}</h3>
    <p>{`The following example deletes the previously-defined cost values for a simple and a downloadable product.`}</p>
    <p><strong parentName="p">{`Sample Usage:`}</strong></p>
    <p><inlineCode parentName="p">{`POST <host>/rest/<store_code>/V1/products/cost-delete`}</inlineCode></p>
    <CodeBlock slots="heading, code" repeat="2" languages="JSON, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "payload-11"
    }}>{`Payload`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "skus": [
    "24-WB03",
    "240-LV09"
  ]
}
`}</code></pre>
    <h4 {...{
      "id": "response-11"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`\`true\`
// indicating the cost values were deleted
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      